const fields={commerce:['nameRestaurant','logo','showLogo','contact','contactVisibility','contactExpanded'],theme:['palette'],tariffs:['priceLevels']};
const appearance={font:['font'],background:['background','backgroundOpacity'],icons:['homeIcons','customIcons'],message:['footerMessage']};
const clone=value=>JSON.parse(JSON.stringify(value));
export function restoreSection(target,source,section){
  if(!fields[section]&&!appearance[section])throw new Error('Sección inválida');
  for(const key of fields[section]||[])target[key]=clone(source[key]);
  for(const key of appearance[section]||[])target.appearance[key]=clone(source.appearance[key]);
}
export function sectionProfile(draft,saved,section){
  const result=clone(saved);
  restoreSection(result,draft,section);
  result.version=draft.version;
  return result;
}
